module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/videos/term-bg-7-e1eca1cdb5a08f0982a4d6ecc9f0c43b.jpg";